<template>
    <div>
        <progress-header />

        <div class="container mt-4">
            <div class="row" v-if="!isLoading">
                <form class="col-12 col-lg-9 mb-2" @submit.prevent="handleSubmit">
                    <div class="card shadow-sm">
                        <div class="px-4 py-3 border-bottom">
                            <h4 class="text-blue-600 font-weight-bold">
                                {{ $t('taxi.pages.options.header') }}
                            </h4>
                            <!--
                            <div class="alert alert-warning">
                                <small>{{ $t('airport_transfers.pages.options_info') }}</small>
                            </div>
                            -->
                        </div>

                        <div class="row px-4 py-3">
                            <div class="col-12 col-lg-4" v-for="(options, type) in travelOptionsByType" :key="type">
                                <div class="text-lg text-blue-600 font-weight-bold mb-3">
                                    {{ type }}
                                </div>

                                <div class="d-flex justify-content-between mb-2" v-for="option in options"
                                    :key="option.id"
                                >
                                    <div>
                                        <div class="font-weight-bold">
                                            {{ option.label }}
                                        </div>

                                        <div class="text-sm">
                                            {{ formatPrice(option.gross_price, currency) }} / {{ $t('piece') }}
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center flex-nowrap">
                                        <font-awesome-icon icon="minus-circle" size="sm" class="cursor-pointer"
                                            @click="handleOptionDecrease(option)"
                                        />

                                        <div class="px-2 text-blue-600 font-weight-bold">
                                            {{ option.quantity }}
                                        </div>

                                        <font-awesome-icon icon="plus-circle" size="sm" class="cursor-pointer"
                                            @click="handleOptionIncrease(option)"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-4 mb-2">
                                <textarea class="form-control w-100" rows="5"
                                    :placeholder="$t('taxi.pages.options.comments')"
                                    v-model="comments"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="my-4">
                        <button type="submit" class="btn btn-primary">
                            {{ $t('next') }}
                        </button>
                    </div>
                </form>

                <div class="col-12 col-lg-3">
                    <the-cart />
                </div>
            </div>
            <div class="d-flex justify-content-center pt-4" v-if="isLoading">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ $t('loading') }}...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TheCart from './components/TheCart';
    import SearchBarInfo from './components/SearchBarInfo';
    import { mapGetters } from 'vuex';
    import { groupBy as _groupBy } from 'lodash-es';
    import ProgressHeader from './components/ProgressHeader';
    import {trackGA} from '@utilities/tracking';
    import BackofficeRepository from '@repositories/BackofficeRepository';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';

    export default {
        components: {
            TheCart,
            SearchBarInfo,
            ProgressHeader,
        },
        data() {
            return {
                isLoading: true,
            };
        },
        computed: {
            ...mapGetters({
                findTravelOptionTypeLabel: 'constants/findTravelOptionTypeLabel',
                searchData: 'airportTransfersSearch/getSearchParameters',
                travelOptions: 'airportTransfersSearch/getTravelOptions',
                defaultCurrencyCode: 'constants/getDefaultCurrencyCode',
                currency: 'airportTransfersSearch/getCurrency',
            }),

            comments: {
                get() {
                    return this.$store.getters['airportTransfersSearch/getTravelOptionComments'];
                },

                set(value) {
                    this.$store.dispatch('airportTransfersSearch/setTravelOptionComments', value);
                },
            },

            travelOptionsByType: function () {
                return _groupBy(this.travelOptions, 'type');
            },
        },

        created() {
            trackGA('checkout_progress', {
                checkout_step: 5,
                checkout_option: window.location.pathname,
            });

            let previousOptionQuantities = [];

            if (this.travelOptions && this.travelOptions.filter(o => o.gross_price).length) {
                this.travelOptions.forEach((option) => {
                    previousOptionQuantities[option.id] = option.quantity;
                });
            }

            BackofficeRepository.additionalOptions('BUS_LINE').then(data => {
                this.$store.dispatch(
                    'airportTransfersSearch/setTravelOptions',
                    backofficeMapsRepository.additionalOptions(data, previousOptionQuantities)
                );
                this.isLoading = false;
            });
        },

        methods: {
            handleSubmit() {
                this.$store.dispatch('airportTransfersSearch/setIsOptionsComplete', true).then(() => {
                    this.$router.push({ name: 'airport-transfers.summary' });
                });
            },
            handleOptionDecrease(option) {
                if (option.quantity === 0) {
                    return;
                }

                this.updateQuantity(option.id, -1);
            },

            handleOptionIncrease(option) {
                this.updateQuantity(option.id, 1);
            },

            updateQuantity(optionId, value) {
                const options = JSON.parse(JSON.stringify(this.travelOptions));
                const option = options.find((option) => option.id === optionId);

                option.quantity += value;

                this.$store.dispatch('airportTransfersSearch/setTravelOptions', options);
            },
        },
    };
</script>
